<template>
  <div id="app">

    <router-view/>
  </div>
</template>

<script>

export default {

  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
  height: calc(100vh);
}
  body{
    height: calc(100vh);
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue